import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 1020px;
  max-width: 100%;
  flex-direction: column;
  background: #f9fafb;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-left: 20px;
`;

export const CloseButton = styled(IconButton)``;

export const Header = styled.div`
  padding: 16px 16px 0 0;
  background: #ffffff;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px 20px;
`;

/** Cartões brancos que agrupam "Selecionar Unidade" e "Propostas da Unidade". */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #eaecf0;
  background: #ffffff;
`;

export const CardTitle = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const FiltrosRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Filtro = styled.div<{ flex?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: ${({ flex }) => flex ?? 1};
  min-width: 220px;
`;

export const FiltroLabel = styled.span`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #344054;
  white-space: nowrap;
`;

export const FiltroCampo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  color: #667085;
  text-align: center;
`;

export const TotalPropostas = styled.p`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #2d5bff;
`;

export const PaginacaoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ButtonBlue = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: #2d5bff !important;
  height: 40px;
  padding: 0 20px;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LightText: any = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #eaefff;
`;
